'use client';

var translations = {
    'Report job': 'Báo cáo tin tuyển dụng',
    'Reported this job': 'Đã báo cáo việc làm này',
    Send: 'Gửi',
    'Please input detail description.': 'Bạn cần nhập mô tả chi tiết.',
    'Your comments make an important contribution to protecting the Job Seeker Community.': 'Ý kiến đóng góp của bạn sẽ góp phần quan trọng để bảo vệ cộng đồng người tìm việc',
    'Report a job successfully': 'Báo cáo việc làm thành công',
    'Scam detection': 'Nhận diện một số hình thức lừa đảo',
    'View detail': 'Xem chi tiết',
    Close: 'Đóng',
    "Can't update this Report Job": 'Không thể cập nhật báo cáo tin tuyển dụng này',
    'Report Job error': 'Lỗi báo cáo tin tuyển dụng',
    'Details of the reason.': 'Mô tả chi tiết lý do báo cáo.',
    login: 'dang-nhap'
};

export { translations as default };
//# sourceMappingURL=translation.js.map
